import Vue from "vue";
import Axios from "axios";
import config from "config";

// Setup $http
const API = Axios.create({
  baseURL: config.CORP_API_URL,
  timeout: 1000 * 15,
});

API.isRefreshing = false;
API.refreshSubscribers = [];

API.subscribeTokenRefresh = (callback) => {
  API.refreshSubscribers.push(callback);
};

API.onRefreshed = (token) => {
  API.refreshSubscribers.map((callback, index) => callback(token, index));
};
// Refresh token interceptor
API.interceptors.response.use(
  (response) => {
    const { headers } = response;

    if (headers["x-auth-token"]) {
      // Token
      Vue.auth.token("access_token", headers["x-auth-token"]);
    }
    return response;
  },
  (error) => {
    const { response } = error;

    if (!response) {
      return error;
    }

    const { status } = response;

    if (status === 401 || status === 498) {
      // on auth error logout
      window.location.href = "/logout";
    }
    return Promise.reject(error);
  }
);

export default API;
